import { service } from '@/ajax/request'

export const getIntelligentList = (params) => (
  service({
    url: '/intelligentDialectics/intelligentInfoPage',
    method: 'POST',
    params
  })
)

// README: 传 merchantId 时返回平台类目(customFlag=0)+品牌方个性类目(customFlag=1)；
// 不传或 body 无 merchantId 时仅返回平台类目（检测体系页复用）
export const getIntelligentType = (params?: { merchantId?: string | number }) => (
  service({
    url: '/intelligentDialectics/getIntelligentType',
    method: 'POST',
    params
  })
)

export const saveOrUpdateIntelligent = (params: any) => (
  service({
    url: '/intelligentDialectics/saveOrUpdateIntelligent',
    method: 'POST',
    params
  })
)

// ===== 品牌方智能评估配置 =====

// 品牌方分页列表
export const getMerchantIntelligentList = (params: {
  merchantId: string | number
  symptomName?: string
  symptomType?: string
  symptomStatus?: number | string
  pageNum: number
  pageSize: number
}) => (
  service({
    url: '/intelligentDialectics/merchantInfoPage',
    method: 'POST',
    params
  })
)

// 品牌方新增/编辑自建项
export const saveOrUpdateMerchantIntelligent = (params: {
  id?: number | null
  merchantId: string | number
  symptomType: string
  symptomName: string
  gender: number
  symptomStatus?: number
}) => (
  service({
    url: '/intelligentDialectics/merchantSaveOrUpdate',
    method: 'POST',
    params
  })
)

// 品牌方状态切换（status 传当前状态，后端取反）
export const updateMerchantIntelligentStatus = (params: {
  merchantId: string | number
  id: number
  customFlag: number
  status: number
}) => (
  service({
    url: '/intelligentDialectics/merchantUpdateStatus',
    method: 'POST',
    params
  })
)

// 品牌方删除自建项
export const deleteMerchantIntelligent = (params: {
  merchantId: string | number
  id: number
}) => (
  service({
    url: '/intelligentDialectics/merchantDelete',
    method: 'POST',
    params
  })
)

// ===== 品牌方智能评估类型配置 =====

// 品牌方类型配置列表（通用类型 + 个性类型，不分页）
export const getMerchantIntelligentTypeList = (params: { merchantId: string | number }) => (
  service({
    url: '/intelligentDialectics/merchantTypeList',
    method: 'POST',
    params
  })
)

// 品牌方类型新增/编辑（新增不传 id，编辑传个性类目 id；typeName 必填≤8字、iconUrl 必填）
export const saveMerchantIntelligentType = (params: {
  id?: number | null
  merchantId: string | number
  typeName: string
  iconUrl: string
}) => (
  service({
    url: '/intelligentDialectics/merchantTypeSave',
    method: 'POST',
    params
  })
)

